<ion-item class="lang-switcher-item">
    <ion-select
        aria-label="Language"
        [interfaceOptions]="langConfig"
        toggleIcon="chevron-down-outline"
        [(ngModel)]="selectedLang"
        (ionChange)="setLang($event.detail.value)"
        mode="ios"
        class="lang-select"
        [class.has-border]="hasBorder"
    >
        @for (lang of languages; track lang) {
        <ion-select-option [value]="lang.code">
            {{ lang.label }}
        </ion-select-option>
        }
    </ion-select>
</ion-item>
